import styled from 'styled-components';

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

export const Left = styled.div``;

export const Right = styled.div``;
